import { useMemo } from 'react'
import moment from 'moment'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FaArrowCircleLeft, FaArrowCircleRight } from 'react-icons/fa'
import PageHeader from '../../../../shared/PageHeader'
import ReportFilters from '../../../../shared/ReportFilters'
import ReportJobsList from '../../../../shared/ReportJobsList'
import usePersistedFilters from '../../../../hooks/usePersistedFilters'
import useAsyncReport from '../../../../hooks/useAsyncReport'
import { addLabRadiologyItemWiseJob, updateLabRadiologyItemWiseJob, removeLabRadiologyItemWiseJob } from '../../../../redux/slices/AppSlice'

const DrsPatientItemWiseReportAsync = () => {
  const { t, i18n } = useTranslation()
  const navigate = useNavigate()
  const jobs = useSelector(state => state.app.labRadiologyItemWiseJobs || [])
  const { filters, setFilters, resetFilters } = usePersistedFilters('drs_patient_item_wise_report', {
    start_date: moment().subtract(1, 'day').toDate(), end_date: moment().toDate(), item: null, format: 'excel'
  })
  const endpoint = '/v3/reports/patient/drs-patient-item-wise/jobs'
  const { loading, downloadingJobs, startJob, downloadReport, removeJob, retryJob } = useAsyncReport({
    addJobAction: addLabRadiologyItemWiseJob, updateJobAction: updateLabRadiologyItemWiseJob,
    removeJobAction: removeLabRadiologyItemWiseJob, createEndpoint: endpoint, statusEndpoint: endpoint,
    downloadEndpoint: endpoint, fileNamePrefix: 'drs_patient_item_wise_report', existingJobs: jobs,
    buildPayload: (value, format) => ({
      start_date: moment(value.start_date).format('YYYY-MM-DD'),
      end_date: moment(value.end_date).format('YYYY-MM-DD'),
      ...(value.item?.non_standard_code ? { non_standard_code: value.item.non_standard_code } : {}),
      format
    })
  })
  const itemOptionsFormat = items => (items || [])
    .filter(item => item?.non_standard_code)
    .map(item => ({
      ...item,
      label: `${item.non_standard_description || item.item_name} | ${item.non_standard_code}`,
      value: item.non_standard_code
    }))

  const filterConfig = useMemo(() => [
    { type: 'date', name: 'start_date', label: 'Start Date', width: 'w-[160px]' },
    { type: 'date', name: 'end_date', label: 'End Date', width: 'w-[160px]' },
    {
      type: 'autocomplete',
      name: 'item',
      label: 'Item (Optional)',
      placeholder: 'Search item, code or description',
      fieldUrl: '/v3/pricelists/report-items/search',
      queryKey: 'search',
      optionsFormat: itemOptionsFormat,
      width: 'w-[300px]'
    },
    { type: 'dropdown', name: 'format', label: 'Format', options: [{ label: 'Excel', value: 'excel' }, { label: 'PDF', value: 'pdf' }], width: 'w-[140px]' }
  ], [])
  const onChange = event => setFilters(prev => ({ ...prev, [event.target.name]: event.target.value }))
  return <div className='main-page-container !overflow-y-auto scrollbar'>
    <PageHeader title={t('DRS Patient Item Wise Report')} iconSize={20} Icon={i18n.language === 'en' ? FaArrowCircleLeft : FaArrowCircleRight} onIconClick={() => navigate(-1)} />
    <ReportFilters filters={filters} onChange={onChange} filterConfig={filterConfig} onGenerate={() => startJob(filters, filters.format)} onReset={resetFilters} loading={loading} />
    <ReportJobsList jobs={jobs} onDownload={downloadReport} onRemove={removeJob} onRetry={retryJob} downloadingJobs={downloadingJobs} reportTitle={t('DRS Patient Item Wise Report')} />
  </div>
}

export default DrsPatientItemWiseReportAsync
